import { CircularProgress } from "@mui/material";

export const Loader = () => {
    return (
        <CircularProgress />
    )
}